import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const buttonClasses = 'btn-width px-2 py-1 fs--2';

function Video3({ src }) {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const [showControls, setShowControls] = useState(false);
  const [videoReady, setVideoReady] = useState(false);

  useEffect(() => {
    // console.log(`Video3 src: ${src}`);
    const video = videoRef.current;
    if (!video) return;
    // console.log(`Video element found`, video);

    const handlePlaying = () => setShowControls(true);

    const handleVolumeChange = () => {
      // Keep React in sync with the actual video element
      setMuted(video.muted);
    };

    const handleCanPlay = () => {
      setVideoReady(true);
    };

    video.addEventListener('playing', handlePlaying, { once: true });
    video.addEventListener('volumechange', handleVolumeChange);
    video.addEventListener('canplay', handleCanPlay);

    // Try autoplay:
    video.play().catch(() => {});

    return () => {
      video.removeEventListener('playing', handlePlaying);
      video.removeEventListener('volumechange', handleVolumeChange);
      video.removeEventListener('canplay', handleCanPlay);
    };
  }, []);

  const handleToggleMute = () => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = !video.muted;

    // ensure playback after unmute
    if (!video.muted && video.paused) {
      video.play().catch(() => {});
    }
  };

  // Restart from beginning
  const handleRestart = () => {
    const video = videoRef.current;
    if (!video) return;

    video.currentTime = 0;
    video.play().catch(() => {
      /* ignore */
    });
  };

  // Fullscreen
  const handleFullscreen = () => {
    const video = videoRef.current;
    if (!video) return;

    // Standard Fullscreen API (most desktop browsers, some mobile)
    if (video.requestFullscreen) {
      video.requestFullscreen();
      return;
    }

    // iOS Safari / older WebKit: dedicated video fullscreen player
    // const anyVideo = video;
    if (video.webkitEnterFullscreen) {
      video.webkitEnterFullscreen();
      return;
    }

    if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen();
      return;
    }
  };

  return (
    <>
      <Row className="flex-center pt-1 pb-0">
        {!videoReady && (
          <div style={{ marginTop: '1rem', marginBottom: '-3rem' }}>
            Loading video…
          </div>
        )}
        <video
          ref={videoRef}
          src={src}
          controls={showControls}
          autoPlay
          muted={muted}
          // loop
          playsInline
          style={{
            aspectRatio: '16 / 9',
            width: '100%',
            maxWidth: '800px',
            display: 'block'
          }}
        ></video>
      </Row>
      <Row className="flex-center pt-1 pb-3">
        <Button
          variant="outline-primary"
          color="primary"
          className={buttonClasses}
          type="submit"
          onClick={handleToggleMute}
          disabled={!videoReady}
        >
          <FontAwesomeIcon icon={muted ? 'volume-mute' : 'volume-up'} />{' '}
          {muted ? 'Unmute' : 'Mute'}
        </Button>
        <Button
          variant="outline-primary"
          color="primary"
          className={`${buttonClasses} ms-2`}
          type="submit"
          onClick={handleRestart}
          disabled={!videoReady}
        >
          <FontAwesomeIcon icon="undo" /> Start Again
        </Button>
        <Button
          variant="outline-primary"
          color="primary"
          className={`${buttonClasses} ms-2`}
          type="submit"
          onClick={handleFullscreen}
          disabled={!videoReady}
        >
          <FontAwesomeIcon icon="expand" /> Full Screen
        </Button>
        {/* <Button
          variant="outline-primary"
          color="primary"
          className={`${buttonClasses} ms-2`}
          type="submit"
          onClick={handleFullscreen}
          disabled={!videoReady}
        >
          <FontAwesomeIcon icon="pause" /> Pause
        </Button> */}
      </Row>
    </>
  );
}
Video3.propTypes = {
  src: PropTypes.string
};

export default Video3;
